import { render, staticRenderFns } from "./DownloadListing.vue?vue&type=template&id=6ba54a73&scoped=true"
import script from "./DownloadListing.vue?vue&type=script&lang=js"
export * from "./DownloadListing.vue?vue&type=script&lang=js"
import style0 from "./DownloadListing.vue?vue&type=style&index=0&id=6ba54a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba54a73",
  null
  
)

export default component.exports